/* eslint-disable max-lines */
export const clinicalNoteStatus = [
  {
    value: 'completed',
    label: 'Locked'
  },
  {
    value: 'pending',
    label: 'Started'
  },
  {
    value: 'incomplete',
    label: 'Not Started'
  },
  {
    value: 'cancelled',
    label: 'Canceled'
  },
  {
    value: 'no_show',
    label: 'No Show'
  }
];

export const clinicalNoteSections = {
  advanced_hp: true,
  vitals: true,
  complaint: true,
  last_visit: true,
  advanced_soap: true,
  subjective: true,
  objective: true,
  assessment: true,
  plan: true,
  cpt_codes: true,
  icd_10_codes: true,
  allergies: true,
  skin_conditions: true,
  eyes_nose_ear_condition: true,
  mouth_throat_condition: true,
  breast_condition: true,
  cardiovascular_condition: true,
  respiratory_condition: true,
  gastrointestinal_condition: true,
  genitourinary_condition: true,
  musculoskeletal_condition: true,
  neurological_condition: true,
  fall_risk: true,
  activity: true,
  general_notes: true
};

export const hpiLocationList = [
  {
    label: 'Head',
    value: 'Head'
  },
  {
    label: 'Neck',
    value: 'Neck'
  },
  {
    label: 'Chest',
    value: 'Chest'
  },
  {
    label: 'Abdomen',
    value: 'Abdomen'
  },
  {
    label: 'Back',
    value: 'Back'
  },
  {
    label: 'Upper extremities',
    value: 'Upper extremities'
  },
  {
    label: 'Lower extremities',
    value: 'Lower extremities'
  },
  {
    label: 'Joints',
    value: 'Joints'
  },
  {
    label: 'Genitourinary',
    value: 'Genitourinary'
  },
  {
    label: 'Skin',
    value: 'Skin'
  }
];

export const hpiDurationList = [
  {
    label: '1 - 3 days',
    value: '1 - 3 days'
  },
  {
    label: '4 - 9 days',
    value: '4 - 9 days'
  },
  {
    label: '10 - 14 days',
    value: '10 - 14 days'
  },
  {
    label: 'More than 2 weeks',
    value: 'More than 2 weeks'
  },
  {
    label: 'Around 6 months',
    value: 'Around 6 months'
  },
  {
    label: 'Around one year',
    value: 'Around one year'
  },
  {
    label: 'More than one year',
    value: 'More than one year'
  }
];

export const hpiTimingList = [
  {
    label: 'In the last week',
    value: 'In the last week'
  },
  {
    label: 'In the last two weeks',
    value: 'In the last two weeks'
  },
  {
    label: 'In the last month',
    value: 'In the last month'
  },
  {
    label: 'In the last six months',
    value: 'In the last six months'
  },
  {
    label: 'Between 6 months and a year',
    value: 'Between 6 months and a year'
  },
  {
    label: 'Over a year',
    value: 'Over a year'
  }
];

export const hpiQualityList = [
  {
    label: 'Dull',
    value: 'Dull'
  },
  {
    label: 'Sharp',
    value: 'Sharp'
  },
  {
    label: 'Stabbing',
    value: 'Stabbing'
  },
  {
    label: 'Burning',
    value: 'Burning'
  },
  {
    label: 'Throbbing',
    value: 'Throbbing'
  },
  {
    label: 'Crushing',
    value: 'Crushing'
  },
  {
    label: 'Nauseating',
    value: 'Nauseating'
  },
  {
    label: 'Shooting',
    value: 'Shooting'
  },
  {
    label: 'Twisting',
    value: 'Twisting'
  },
  {
    label: 'Stretching',
    value: 'Stretching'
  }
];

export const hpiContextList = [
  {
    label: 'Lifting objects',
    value: 'Lifting objects'
  },
  {
    label: 'Working',
    value: 'Working'
  },
  {
    label: 'Physical Activity',
    value: 'Physical Activity'
  },
  {
    label: 'Everyday life',
    value: 'Everyday life'
  },
  {
    label: 'Sleeping',
    value: 'Sleeping'
  },
  {
    label: 'Sitting',
    value: 'Sitting'
  },
  {
    label: 'Bending',
    value: 'Bending'
  },
  {
    label: 'Stress',
    value: 'Stress'
  },
  {
    label: 'Visual stimulation (screens, bright lights)',
    value: 'Visual stimulation (screens, bright lights)'
  },
  {
    label: 'Climbing stairs',
    value: 'Climbing stairs'
  },
  {
    label: 'Pregnancy or child care',
    value: 'Pregnancy or child care'
  },
  {
    label: 'Carrying purse, backpack, or brief case',
    value: 'Carrying purse, backpack, or brief case'
  }
];

export const hpiRelievingFactorList = [
  { label: 'Rest or relaxation', value: 'Rest or relaxation' },
  { label: 'Change in position', value: 'Change in position' },
  { label: 'Over-the-counter medication', value: 'Over-the-counter medication' },
  { label: 'Prescription medication', value: 'Prescription medication' },
  { label: 'Ice or Heat Application', value: 'Ice or Heat Application' },
  { label: 'Hydration', value: 'Hydration' },
  { label: 'Healthy diet', value: 'Healthy diet' },
  { label: 'Exercise', value: 'Exercise' },
  { label: 'Compression', value: 'Compression' },
  { label: 'Massage or Physical Therapy', value: 'Massage or Physical Therapy' },
  { label: 'Breathing techniques', value: 'Breathing techniques' },
  { label: 'Distraction', value: 'Distraction' },
  { label: 'Avoiding triggers', value: 'Avoiding triggers' },
  { label: 'Use of assistive devices', value: 'Use of assistive devices' }
];

export const howLongAgo = [
  {
    label: 'One day',
    value: 'One day'
  },
  {
    label: 'One week',
    value: 'One week'
  },
  {
    label: 'Two weeks',
    value: 'Two weeks'
  },
  {
    label: 'One month',
    value: 'One monthy'
  },
  {
    label: 'Six months',
    value: 'Six months'
  },
  {
    label: 'More than six months',
    value: 'More than six months'
  }
];

export const growthOptionChart = [
  { label: 'Weight For Age: Birth to 5 years', value: 'weight_for_age' },
  { label: 'Head Circumference For Age: Birth to 5 years', value: 'head_circumference_for_age' },
  { label: 'Length For Age: Birth to 5 years', value: 'length_for_age' },
  { label: 'Weight For Length: Birth to 2 years', value: 'weight_for_length' },
  { label: 'Weight For Height: 2 to 5 years', value: 'weight_for_height' }
];

export const growthOptionGender = [
  { label: 'Boys', value: 'boys' },
  { label: 'Girls', value: 'girls' }
];

export const growthOptionMeasurement = [
  { label: 'Month', value: 'month', unit: 'month' },
  { label: 'Height', value: 'height', unit: 'cm' },
  { label: 'Length', value: 'length', unit: 'cm' }
];
